module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageDesert/DIGITAL_CAMOUFLAGE_DESERT_france.f4ff3696.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageDesert/DIGITAL_CAMOUFLAGE_DESERT_france.png
// module id = 1220
// module chunks = 16